import classNames from "classnames";
import { ReactNode } from "react";
import "./Fieldset.scss";

const Fieldset = ({
	children,
	className,
	...props
}: {
	children?: ReactNode;
	className?: string;
}) => {
	return (
		<div role="group" className={classNames("fieldset", className)} {...props}>
			{children}
		</div>
	);
};

export default Fieldset;
